export default __webpack_public_path__ + "static/media/morningsnacks.5e9f36be.svg";